import { render, staticRenderFns } from "./caracteristicas.vue?vue&type=template&id=deee03aa&scoped=true"
import script from "./caracteristicas.vue?vue&type=script&lang=js"
export * from "./caracteristicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deee03aa",
  null
  
)

export default component.exports